import {
  Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { useEffect } from "react";
import OperationReportService from "../../../Services/Reports/OperationReportService";
import { getDate } from "../../Utils/Common";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  border: " 1px solid black",
}));
function CheckListExcelReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "11rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: 'Times New Roman',
  };
  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [loading, setloading] = useState(false)

  const [showProcs, setshowProcs] = useState(false)
  const [ReportProcs, setReportProcs] = useState(false)
  const [clearProcs, setclearProcs] = useState(false)

  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);

  const [CheckListXlValues, setCheckListXlValues] = useState({
    from: getDate(),
    to: getDate(),
    cust: 'ALL',
    OperationType: 'ALL',
    branch: '-1',
    job: '',
  });
  const fromhandlechange = (e) => {
    setCheckListXlValues({ ...CheckListXlValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setCheckListXlValues({ ...CheckListXlValues, to: e.target.value })
  };
  const custhandlechange = (e) => {
    setCheckListXlValues({ ...CheckListXlValues, cust: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const porthandlechange = (e) => {
    setCheckListXlValues({ ...CheckListXlValues, OperationType: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const branchhandlechange = (e) => {
    setCheckListXlValues({ ...CheckListXlValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const jobhandlechange = (e) => {
    setCheckListXlValues({ ...CheckListXlValues, job: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  ///
  const getfunctions = () => {
    OperationReportService.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
    OperationReportService.getCustomerBasedCustomerType('Importer').then(res => {
      setdetails2(res.data);
    })
  }
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    var imp_cd, reginlCd, jobNo, operationType = '';
    if (CheckListXlValues.cust === 'ALL') {
      imp_cd = '-1'
    } else {
      imp_cd = CheckListXlValues.cust;
    }
    if (CheckListXlValues.branch === 'ALL' || CheckListXlValues.branch === '') {
      reginlCd = -1
    } else {
      reginlCd = CheckListXlValues.branch;
    }
    if (CheckListXlValues.OperationType === 'ALL') {
      operationType = '-1'
    } else {
      operationType = CheckListXlValues.OperationType
    }
    if (CheckListXlValues.job === '') {
      jobNo = '-1'
    } else {
      jobNo = CheckListXlValues.job
    }
    let details = {
      importer_iec_no: imp_cd, regionalId: reginlCd, consignmentNumber: jobNo, operationType: operationType,
      transitTypeId: '-1', customId: -1, clearanceStatus: '-1', employeeId: -1,
      fromDate: CheckListXlValues.from, toDate: CheckListXlValues.to,
    }
    OperationReportService.getChecklistExcelReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const ExportReportClick = () => {
    setReportProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setReportProcs(false)
    } else {
      var tableContent='',contenall = '';
      console.log('leng '+details3.length)
      for (let i = 0; i < details3.length; ++i) {

        if (details3[i].regionalName === ''|| !details3[i].regionalName) {
          tableContent += " !";
        } else {
          tableContent += details3[i].regionalName + '!';
        }

        if (details3[i].operationType === ''|| !details3[i].operationType) {
          tableContent += " !";
        }
        else {
          tableContent += details3[i].operationType + '!';
        }
        if (details3[i].licenceNo === '' || !details3[i].licenceNo) {
          tableContent += " !";
        } else {
          tableContent += details3[i].licenceNo + '!';
        }
        if (details3[i].boeENo === '' || !details3[i].boeENo) {
          tableContent +=  " !";
        } else {
          tableContent += details3[i].boeENo +'!';
        }
        if (details3[i].consignmentNumber === '' || !details3[i].consignmentNumber) {
          tableContent += " !";
        } else {
          tableContent += details3[i].consignmentNumber + '!';
        }
        if (details3[i].transitDate === '' || !details3[i].transitDate ) {
          tableContent += " !";
        } else {
          tableContent += details3[i].transitDate + '!';
        }
        if (details3[i].beType === '' || !details3[i].beType) {
          tableContent += " !"
        } else {
          tableContent += details3[i].beType + '!';
        }
        if (details3[i].endUseCode === '' || !details3[i].endUseCode) {
          tableContent += " !"
        } else {
          tableContent += details3[i].endUseCode + '!';
        }
        if (details3[i].hawbDate === ''|| !details3[i].hawbDate) {
          tableContent += " !"
        } else {
          tableContent += details3[i].hawbDate + '!';
        }
        if (details3[i].preAlert === '' || !details3[i].preAlert ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].preAlert +'  !';
        }
        if (details3[i].igmDate === '' || !details3[i].igmDate) {
          tableContent += " !"
        } else {
          tableContent += details3[i].igmDate + '!';
        }
        if (details3[i].boeDate === '' || !details3[i].boeDate ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].boeDate +'!';
        }
        if (details3[i].oocReleaseDate === '' || !details3[i].oocReleaseDate ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].oocReleaseDate + '!';
        }
        if (details3[i].examDate === '' || !details3[i].examDate  ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].examDate + '!';
        }
        if (details3[i].transitTypeName === '' || !details3[i].transitTypeName ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].transitTypeName + '!';
        }
        if (details3[i].vesselName === '' || !details3[i].vesselName ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].vesselName + '!';
        }
        if (details3[i].carrierCode === '' || ! details3[i].carrierCode ) {
          tableContent += " !"
        } else {
          tableContent +=  details3[i].carrierCode + '!';
        }
        if (details3[i].invValue === '' || !details3[i].invValue ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].invValue +'!';
        }
        if (details3[i].currency_code === '' || !details3[i].currency_code  ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].currency_code + '!';
        }
        if (details3[i].grossWt === '' || !details3[i].grossWt  ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].grossWt +'!';
        }
        if (details3[i].noPkg === '' || !details3[i].noPkg  ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].noPkg + '!';
        }
        if (details3[i].unitCode ==='' || !details3[i].unitCode  ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].unitCode + '!';
        }
        if (details3[i].originCountry === '' || !details3[i].originCountry ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].originCountry +'!';
        }
        if (details3[i].desCountry === '' || !details3[i].desCountry ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].desCountry +'!';
        }
        if (details3[i].mawbNo === '' || !details3[i].mawbNo ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].mawbNo +'!';
        }
        if (details3[i].hawb_no === '' || !details3[i].hawb_no ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].hawb_no + '!';
        }
        if (details3[i].terms_code === '' || !details3[i].terms_code ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].terms_code + '!';
        }
        if (details3[i].port === '' || !details3[i].port ) {
          tableContent += " !"
        } else {
          tableContent += details3[i].port + '!';
        }
        if (details3[i].cusHouseCode === '' || !details3[i].cusHouseCode ) {
          tableContent +=  " !"
        } else {
          tableContent += details3[i].cusHouseCode +'!';
        }
        if (details3[i].cargoLoc === '' || !details3[i].cargoLoc ) {
          tableContent +=  " !";
        } else {
          tableContent += details3[i].cargoLoc +'!';
        }
        if (details3[i].senderName !== '') {
          tableContent += details3[i].senderName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].receiverName !== '') {
          tableContent += details3[i].receiverName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].manufactureName !== '') {
          tableContent += details3[i].manufactureName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importer_iec_no !== '') {
          tableContent += details3[i].importer_iec_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].relParty !== '') {
          tableContent += details3[i].relParty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bond !== '') {
          tableContent += details3[i].bond + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cusExam !== '') {
          tableContent += details3[i].cusExam + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].brokerFees !== '') {
          tableContent += details3[i].brokerFees + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].brokerCur !== '') {
          tableContent += details3[i].brokerCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].demAmt !== '') {
          tableContent += details3[i].demAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].demuCur !== '') {
          tableContent += details3[i].demuCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cusFees !== '') {
          tableContent += details3[i].cusFees + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cusCur !== '') {
          tableContent += details3[i].cusCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].regFees !== '') {
          tableContent += details3[i].regFees + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].regCur !== '') {
          tableContent += details3[i].regCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].examFees !== '') {
          tableContent += details3[i].examFees + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].examCur !== '') {
          tableContent += details3[i].examCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impFees1 !== '') {
          tableContent += details3[i].impFees1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impCur1 !== '') {
          tableContent += details3[i].impCur1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impFees2 !== '') {
          tableContent += details3[i].impFees2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impCur2 !== '') {
          tableContent += details3[i].impCur2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impFees3 !== '') {
          tableContent += details3[i].impFees3 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impCur3 !== '') {
          tableContent += details3[i].impCur3 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].lineNo !== '') {
          tableContent += details3[i].lineNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].purOrderNo !== '') {
          tableContent += details3[i].purOrderNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceNumber !== '') {
          tableContent += details3[i].invoiceNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].supplierAddress !== '') {
          tableContent += details3[i].supplierAddress + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemNo !== '') {
          tableContent += details3[i].itemNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemDesc !== '') {
          tableContent += details3[i].itemDesc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hsCode !== '') {
          tableContent += details3[i].hsCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].countryOfOrigin !== '') {
          tableContent += details3[i].countryOfOrigin + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].quantityString !== '') {
          tableContent += details3[i].quantityString + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unit !== '') {
          tableContent += details3[i].unit + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unitQty !== '') {
          tableContent += details3[i].unitQty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceVal !== '') {
          tableContent += details3[i].invoiceVal + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invCur !== '') {
          tableContent += details3[i].invCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].untPrice !== '') {
          tableContent += details3[i].untPrice + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unitCur !== '') {
          tableContent += details3[i].unitCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].assbleValue !== '') {
          tableContent += details3[i].assbleValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].assCur !== '') {
          tableContent += details3[i].assCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyAmount !== '') {
          tableContent += details3[i].dutyAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyCur !== '') {
          tableContent += details3[i].dutyCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyRate !== '') {
          tableContent += details3[i].dutyRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].overFrtAmt !== '') {
          tableContent += details3[i].overFrtAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].overFrtCur !== '') {
          tableContent += details3[i].overFrtCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].oriFrtAmt !== '') {
          tableContent += details3[i].oriFrtAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].oriFrtCur !== '') {
          tableContent += details3[i].oriFrtCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].desFrtAmt !== '') {
          tableContent += details3[i].desFrtAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].desFrtCur !== '') {
          tableContent += details3[i].desFrtCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insAmt !== '') {
          tableContent += details3[i].insAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].insCur !== '') {
          tableContent += details3[i].insCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].royAmt !== '') {
          tableContent += details3[i].royAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].royCur !== '') {
          tableContent += details3[i].royCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].contraAmt !== '') {
          tableContent += details3[i].contraAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].contraCur !== '') {
          tableContent += details3[i].contraCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].disAmt !== '') {
          tableContent += details3[i].disAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].disCur !== '') {
          tableContent += details3[i].disCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].vatAmt !== '') {
          tableContent += details3[i].vatAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].vatCur !== '') {
          tableContent += details3[i].vatCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].vatRate !== '') {
          tableContent += details3[i].vatRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gstAmt !== '') {
          tableContent += details3[i].gstAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gstCur !== '') {
          tableContent += details3[i].gstCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].gstRate !== '') {
          tableContent += details3[i].gstRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otherAmt1 !== '') {
          tableContent += details3[i].otherAmt1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otherCur1 !== '') {
          tableContent += details3[i].otherCur1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otherRate1 !== '') {
          tableContent += details3[i].otherRate1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otherAmt2 !== '') {
          tableContent += details3[i].otherAmt2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otherCur2 !== '') {
          tableContent += details3[i].otherCur2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].otherRate2 !== '') {
          tableContent += details3[i].otherRate2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].exRate !== '') {
          tableContent += details3[i].exRate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].bcdNotNo !== '') {
          tableContent += details3[i].bcdNotNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].tariffSuplmt !== '') {
          tableContent += details3[i].tariffSuplmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impLicNo !== '') {
          tableContent += details3[i].impLicNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].pgaCode1 !== '') {
          tableContent += details3[i].pgaCode1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].pgaCode2 !== '') {
          tableContent += details3[i].pgaCode2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addNotNo !== '') {
          tableContent += details3[i].addNotNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cvdNotNo !== '') {
          tableContent += details3[i].cvdNotNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].auntiDumpDuty !== '') {
          tableContent += details3[i].auntiDumpDuty + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].addCur !== '') {
          tableContent += details3[i].addCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].counterveilling !== '') {
          tableContent += details3[i].counterveilling + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cvdCur !== '') {
          tableContent += details3[i].cvdCur + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impProdFees1 !== '') {
          tableContent += details3[i].impProdFees1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impProdCur1 !== '') {
          tableContent += details3[i].impProdCur1 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impProdFees2 !== '') {
          tableContent += details3[i].impProdFees2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impProdCur2 !== '') {
          tableContent += details3[i].impProdCur2 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impProdFees3 !== '') {
          tableContent += details3[i].impProdFees3 + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].impProdCur3 !== '') {
          tableContent += details3[i].impProdCur3 + "#"
        } else {
          tableContent += '  #';
        }
       
      }
      contenall += tableContent;
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,CHECKLIST EXCEL REPORT", headerDetails: "1,1,FROM DATE : " + CheckListXlValues.from + "/4,1,TO DATE : " + CheckListXlValues.to,
        tableHeader: "0,3,Sl.No/1,3,Branch Name/2,3,Operation Type/3,3,Broker LicenceNo/4,3,BE_SB No/5,3,Job No/6,3,Job Date/7,3,BE_SB Type/8,3,End Use Code/9,3,Awb_Hbl Date/10,3,Receipt of PreAlert/11,3,IGM_Inward Date/12,3,BE_SB Date/13,3,OOC Release Date/14,3,Exam Date/15,3,Mode of Transport/16,3,Vessel Name/17,3,Carrier Code/18,3,Invoice Value/19,3,Invoice Currency/20,3,Gross Weight/21,3,No Of Pkg/22,3,pkg Code/23,3,Country of Export/24,3,Country of Destination/25,3,MAWB_MBL No/26,3,HAWB_HBL No/27,3,Terms/28,3,Place of Departure/29,3,Custom House Code/30,3,Cargo Location/31,3,Name of Shipper/32,3,Name of Consignee/33,3,Manufacture Name/34,3,IEC_Branch Code/35,3,Related Party/36,3,In_Bond/37,3,Custom Examination/38,3,Broker Fees/39,3,Broker Currency/40,3,Demurrage Charges/41,3,Demurrage Currency/42,3,Customs Fees/43,3,Custms Currency/44,3,Regulatory Fees/45,3,Regulatory Currency/46,3,Exam Fees/47,3,Exam Currency/48,3,Import Fees1/49,3,Import Currency1/50,3,Import Fees2/51,3,Import Currency2/52,3,Import Fees3/53,3,Import Currency3/54,3,Line No/55,3,Purchase Order No/56,3,Invoice No/57,3,Supplier Address/58,3,Item No/59,3,Item Description/60,3,Hs Code/61,3,Country of Origin/62,3,Quantity/63,3,UOM/64,3,Unit Qty/65,3,Invoice Value/66,3,Invoice Currency/67,3,Unit Price/68,3,Unit Currency/69,3,Assessable Value/70,3,Assessable Currency/71,3,Duty Amount/72,3,Duty Currency/73,3,Duty Rate/74,3,OverseasFreightAmount/75,3,OverseasFreightCurrency/76,3,OriginFreightAmount/77,3,OriginFreightCurrency/78,3,DestinationFreightAmont/79,3,DestinationFreightCurrency/80,3,Insurance Amount/81,3,Insurance Currency/82,3,Royalty Amount/83,3,Royalty Currency/84,3,Contra Amount/85,3,Contra Currency/86,3,Discount Amount/87,3,Discount Currency/88,3,VAT Amount/89,3,VAT Currency/90,3,VAT Rate/91,3,GSt Amount/92,3,GSt Currency/93,3,GST Rate/94,3,Other Tax1 Amount/95,3,Other Tax1 Currency/96,3,Other Tax1 Rate/97,3,Other Tax2 Amount/98,3,Other Tax2 Currency/99,3,Other Tax2 Rate/100,3,Exchange Rate/101,3,BCD NotNoSlNo/102,3,Tariff Supplement/103,3,Import LicenceNo/104,3,PGA Code1/105,3,PGA Code2/106,3,Add NotNoSlNo/107,3,CVD NotNoSlNo/108,3,AuntiDumpingDuty/109,3,add Currency/110,3,Counterveiling DutyAmount/111,3,CVD Currency/112,3,ImportProductFees1/113,3,ImportProductCurrency1/114,3,ImportProductFees2/115,3,ImportProductCurrency2/116,3,ImportProductFees3/117,3,ImportProductCurrency3",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "Checklist", totalNumberOfColumn: 118, tableContent: contenall.substring(0, contenall.length - 1),
      }
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setReportProcs(false)
  }
  const clearOnClick = () => {
    setclearProcs(true)
    setReportProcs(false)
    setshowProcs(false)
    setCheckListXlValues({ ...CheckListXlValues, branch: '', cust: 'ALL', from: getDate(), to: getDate(), job: '', OperationType: 'ALL', })
    setclearProcs(false)
    setdetails3([])
    setFilteredDetails([])
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);
  //table search
  const brnchNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { brnchOnchange(e.target.value) }} />
  }
  const oprTypNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { oprtypeOnchange(e.target.value) }} />
  }
  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const modeSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { modeOnchange(e.target.value) }} />
  }
  const plcDepSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { plcDepOnchange(e.target.value) }} />
  }
  const nmShipperSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { nmShipperOnchange(e.target.value) }} />
  }
  const nameConsigneeSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { NameConsigneeOnchange(e.target.value) }} />
  }
  const invcNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { invcNoOnchange(e.target.value) }} />
  }
  //
  const brnchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const oprtypeOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.operationType.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const modeOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.transitTypeName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const plcDepOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.port.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const nmShipperOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.senderName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const NameConsigneeOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.receiverName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const invcNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.invoiceNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Grid>
              <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}>
                <center>CHECKLIST EXCEL REPORT</center></div>
              <Row>
                <Col>
                  <label style={mystyle1}>From Date</label>
                </Col>
                <Col>
                  <Form.Control size="sm" type="date" style={mystyle} value={CheckListXlValues.from} onChange={fromhandlechange} />
                </Col>
                <Col>
                  <label style={mystyle1}>To Date</label>{" "}
                </Col>
                <Col>
                  <Form.Control size="sm" type="date" style={mystyle} value={CheckListXlValues.to} onChange={tohandlechange} />
                </Col>
                <Col>
                  <label style={mystyle1}>Job No</label>{" "}
                </Col>
                <Col>
                  <Form.Control size="sm" type="text" style={mystyle} value={CheckListXlValues.job} onChange={jobhandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  <label style={mystyle1}>Branch Name</label>{" "}
                </Col>
                <Col>
                  <Form.Select size="sm" style={mystyle} value={CheckListXlValues.branch} onChange={branchhandlechange}>
                    {details1.map(trns => (
                      <option value={trns.regionId}>{trns.regionalName}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col>
                  <label style={mystyle1}>Customer</label>{" "}
                </Col>
                <Col>
                  <Form.Select type="text" list="code" style={mystyle} size="sm" value={CheckListXlValues.cust} onChange={custhandlechange}>
                    <option value={'ALL'}>All</option>
                    {details2.map(trns => (
                      <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col>
                  <label style={mystyle1}>Operation Type</label>{" "}
                </Col>
                <Col>
                  <Form.Select size="sm" style={mystyle} value={CheckListXlValues.OperationType} onChange={porthandlechange}>
                    <option value='ALL'>All</option>
                    <option value='IMPORT'>IMPORT</option>
                    <option value='EXPORT'>EXPORT</option>
                    <option value='COURIER'>COURIER</option>
                  </Form.Select>
                </Col>
              </Row>
            </Grid>
            <Row className="mt-1 mb-1">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button variant="primary"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={showBtnClick}>{showProcs ? 'processing...' : 'Show'}
                </Button>
                &nbsp;
                <Button variant="success"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={ExportReportClick}>{ReportProcs ? 'processing...' : 'Report'}
                </Button>
                &nbsp;
                <Button variant="danger"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={clearOnClick}>{clearProcs ? 'processing...' : 'Clear'}
                </Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 400 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>BranchName{brnchNmSrch()}</StyledTableCell>
                      <StyledTableCell>OperationType{oprTypNmSrch()}</StyledTableCell>
                      <StyledTableCell>BrokerLicenseNo</StyledTableCell>
                      <StyledTableCell>BE/SB_No</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobDate</StyledTableCell>
                      <StyledTableCell>BE/SB_Type</StyledTableCell>
                      <StyledTableCell>BE/SB_date</StyledTableCell>
                      <StyledTableCell>Mode{modeSrch()}</StyledTableCell>
                      <StyledTableCell>IGM/Inward_Date</StyledTableCell>
                      <StyledTableCell>AWB/HBL_Date</StyledTableCell>
                      <StyledTableCell>EndUseCode</StyledTableCell>
                      <StyledTableCell>InvoiceValue</StyledTableCell>
                      <StyledTableCell>InvoiceCurrency</StyledTableCell>
                      <StyledTableCell>NoOfPkg</StyledTableCell>
                      <StyledTableCell>Gross_WT</StyledTableCell>
                      <StyledTableCell>MAWB/MBL</StyledTableCell>
                      <StyledTableCell>HAWB/HBL</StyledTableCell>
                      <StyledTableCell>Terms</StyledTableCell>
                      <StyledTableCell>PlaceOfDeparture{plcDepSrch()}</StyledTableCell>
                      <StyledTableCell>CustomPortCode</StyledTableCell>
                      <StyledTableCell>IEC/Branch_Code</StyledTableCell>
                      <StyledTableCell>Name_Of_Shipper{nmShipperSrch()}</StyledTableCell>
                      <StyledTableCell>Name_Of_Consignee{nameConsigneeSrch()}</StyledTableCell>
                      <StyledTableCell>InvoiceNo{invcNoSrch()}</StyledTableCell>
                      <StyledTableCell>SupplierAddress</StyledTableCell>
                      <StyledTableCell>ItemNo</StyledTableCell>
                      <StyledTableCell>ItemDescription</StyledTableCell>
                      <StyledTableCell>HS_Code</StyledTableCell>
                      <StyledTableCell>Country_Of_Origin</StyledTableCell>
                      <StyledTableCell>Quantity</StyledTableCell>
                      <StyledTableCell>Unit</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.licenceNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boeENo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boeDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitTypeName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.endUseCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.currency_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noPkg}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grossWt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.terms_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.port}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cusHouseCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_iec_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.senderName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.receiverName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supplierAddress}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemDesc}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hsCode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.countryOfOrigin}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.quantityString}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unit}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}
export default CheckListExcelReport;
